import { Language } from './locales';
import { SeoMetaEntry } from '../hooks/useSeoMeta';

type SeoMetaMap = Record<Language, SeoMetaEntry>;

export const SEO_META: Record<string, SeoMetaMap> = {
  home: {
    de: {
      title: 'HenselX – IT Infrastruktur, KI & Web Entwicklung',
      description: 'Sovereign IT-Infrastruktur, lokale KI & Web-Entwicklung aus Acri, Italien. DSGVO-konform, 100% EU-gehostet. Jetzt kostenlose Beratung anfragen.',
    },
    it: {
      title: 'HenselX – Infrastruttura IT, AI & Web Development',
      description: 'Infrastruttura IT sovrana, AI locale e sviluppo web professionale da Acri, Italia. Conformità GDPR, 100% ospitato in UE. Richiedi una consulenza gratuita.',
    },
    en: {
      title: 'HenselX – IT Infrastructure, Local AI & Web Dev',
      description: 'Sovereign IT infrastructure, local AI solutions and professional web development from Acri, Italy. GDPR-compliant, 100% EU-hosted. Request a free consultation.',
    },
  },

  about: {
    de: {
      title: 'Über HenselX | Sovereign IT aus Acri, Italien',
      description: 'HenselX ist eine Sovereign-IT-Agentur aus Acri, Kalabrien. Wir bauen sichere IT-Infrastrukturen, private KI-Systeme und skalierbare Web-Anwendungen.',
    },
    it: {
      title: 'Chi siamo | HenselX – IT Sovrana da Acri, Italia',
      description: 'HenselX è un\'agenzia IT sovrana di Acri, Calabria. Costruiamo infrastrutture IT sicure, sistemi AI privati e applicazioni web scalabili per le aziende.',
    },
    en: {
      title: 'About HenselX | Sovereign IT from Acri, Italy',
      description: 'HenselX is a sovereign IT agency from Acri, Calabria. We build secure IT infrastructures, private AI systems, and scalable web applications for businesses.',
    },
  },

  'services/infrastructure': {
    de: {
      title: 'IT Infrastruktur | Bare Metal & Private Cloud – HenselX',
      description: 'Custom Bare-Metal-Server, Private Cloud und Netzwerklösungen. Keine US-Clouds, kein CLOUD Act. 100% DSGVO-konform aus Acri, Kalabrien. Jetzt anfragen.',
    },
    it: {
      title: 'Infrastruttura IT | Bare Metal & Private Cloud – HenselX',
      description: 'Server Bare Metal, Private Cloud e soluzioni di rete personalizzate. Nessun cloud USA, nessun CLOUD Act. 100% GDPR da Acri, Calabria. Richiedi un preventivo.',
    },
    en: {
      title: 'IT Infrastructure | Bare Metal & Private Cloud – HenselX',
      description: 'Custom bare-metal servers, private cloud and network solutions. No US-clouds, no CLOUD Act. 100% GDPR-compliant from Acri, Calabria. Request a quote today.',
    },
  },

  'services/ai': {
    de: {
      title: 'Lokale KI & Private LLMs | EU-Datenhoheit – HenselX',
      description: 'Private LLMs und lokale KI-Lösungen für Unternehmen. Mistral, Ollama & HuggingFace auf eigener Hardware. EU-Datenhoheit garantiert – HenselX, Acri.',
    },
    it: {
      title: 'AI Locale & LLM Privati | Sovranità Dati EU – HenselX',
      description: 'LLM privati e soluzioni AI locali per aziende. Mistral, Ollama & HuggingFace su hardware proprietario. Sovranità dei dati EU garantita – HenselX, Acri.',
    },
    en: {
      title: 'Local AI & Private LLMs | EU Data Sovereignty – HenselX',
      description: 'Private LLMs and local AI solutions for businesses. Mistral, Ollama & HuggingFace on your own hardware. EU data sovereignty guaranteed – HenselX, Acri.',
    },
  },

  'services/web': {
    de: {
      title: 'Web & App Entwicklung | React & Next.js – HenselX',
      description: 'Scalable Web-Apps und Anwendungen mit React, Next.js & TypeScript. EU-gehostet, DSGVO-konform, performance-optimiert. Ihr Web-Projekt mit HenselX, Acri.',
    },
    it: {
      title: 'Web & App Development | React & Next.js – HenselX',
      description: 'Web app scalabili con React, Next.js & TypeScript. Ospitate in UE, conformi GDPR, ottimizzate per le performance – HenselX, Acri, Calabria, Italia.',
    },
    en: {
      title: 'Web & App Development | React & Next.js – HenselX',
      description: 'Scalable web apps and applications with React, Next.js & TypeScript. EU-hosted, GDPR-compliant, performance-optimised. Your web project with HenselX.',
    },
  },

  contact: {
    de: {
      title: 'Kontakt | Projekt anfragen – HenselX',
      description: 'Nehmen Sie Kontakt auf und starten Sie Ihr IT-Projekt. Kostenlose Erstberatung für IT-Infrastruktur, KI-Lösungen und Web-Entwicklung. HenselX, Acri, Italien.',
    },
    it: {
      title: 'Contatto | Avvia il tuo progetto – HenselX',
      description: 'Contattaci e avvia il tuo progetto IT. Consulenza iniziale gratuita per infrastruttura, soluzioni AI e sviluppo web con HenselX da Acri, Calabria, Italia.',
    },
    en: {
      title: 'Contact | Start your project – HenselX',
      description: 'Get in touch and start your IT project. Free initial consultation for IT infrastructure, AI solutions and web development. HenselX, Acri, Calabria, Italy.',
    },
  },

  blog: {
    de: {
      title: 'Blog | Tech Insights & IT Artikel – HenselX',
      description: 'Aktuelle Artikel zu IT-Infrastruktur, Künstlicher Intelligenz, DSGVO und Web-Entwicklung. Tech Insights vom HenselX Team aus Acri, Kalabrien, Italien.',
    },
    it: {
      title: 'Blog | Tech Insights & Articoli IT – HenselX',
      description: 'Articoli recenti su infrastruttura IT, intelligenza artificiale, GDPR e sviluppo web. Tech insights dal team HenselX di Acri, Calabria, Italia.',
    },
    en: {
      title: 'Blog | Tech Insights & IT Articles – HenselX',
      description: 'Latest articles on IT infrastructure, artificial intelligence, GDPR and web development. Tech insights from the HenselX team in Acri, Calabria, Italy.',
    },
  },

  referenzen: {
    de: {
      title: 'Referenzen | Projekte & Portfolio – HenselX',
      description: 'Abgeschlossene Projekte: Netzwerk-Infrastrukturen, private KI-Deployments und Web-Applikationen für Unternehmen in der EU. HenselX Portfolio, Acri.',
    },
    it: {
      title: 'Referenze | Progetti & Portfolio – HenselX',
      description: 'Progetti completati: infrastrutture di rete, deployment AI privati e applicazioni web per aziende nell\'UE. Portfolio HenselX da Acri, Calabria, Italia.',
    },
    en: {
      title: 'References | Projects & Portfolio – HenselX',
      description: 'Completed projects: network infrastructures, private AI deployments and web applications for EU-based businesses. HenselX portfolio from Acri, Calabria.',
    },
  },

  impressum: {
    de: {
      title: 'Impressum | HenselX',
      description: 'Gesetzliche Pflichtangaben nach § 5 TMG für HenselX. Anbieterkennung, Kontaktdaten und verantwortliche Person. Marc Hensel, Acri (CS), Italia.',
    },
    it: {
      title: 'Note Legali | HenselX',
      description: 'Informazioni obbligatorie ai sensi del § 5 TMG per HenselX. Identificazione del fornitore, dati di contatto e persona responsabile. Acri (CS), Italia.',
    },
    en: {
      title: 'Legal Notice | HenselX',
      description: 'Mandatory legal information under § 5 TMG for HenselX. Provider identification, contact details and responsible person. Marc Hensel, Acri (CS), Italy.',
    },
  },

  datenschutz: {
    de: {
      title: 'Datenschutzerklärung (DSGVO) | HenselX',
      description: 'Datenschutzerklärung von HenselX gemäß DSGVO. Informationen zu Datenerhebung, -verarbeitung und Ihren Rechten als betroffene Person. Acri, Italia.',
    },
    it: {
      title: 'Informativa sulla Privacy (GDPR) | HenselX',
      description: 'Informativa sulla privacy di HenselX ai sensi del GDPR. Informazioni sulla raccolta, elaborazione dei dati e i tuoi diritti come interessato.',
    },
    en: {
      title: 'Privacy Policy (GDPR) | HenselX',
      description: 'Privacy policy of HenselX in accordance with GDPR. Information on data collection, processing and your rights as a data subject. Acri, Italy.',
    },
  },
};
